import { render, staticRenderFns } from "./products-container.vue?vue&type=template&id=673af39e&scoped=true&lang=pug"
import script from "./products-container.js?vue&type=script&lang=js&external"
export * from "./products-container.js?vue&type=script&lang=js&external"
import style0 from "./products-container.vue?vue&type=style&index=0&id=673af39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673af39e",
  null
  
)

export default component.exports